/** Frame budget of the sign-in territory (B-18): requestAnimationFrame ticks at the refresh rate
 *  of the screen, the scene is painted at most 30 times a second. */

const FRAME_MS = 1000 / 30;
// Ticks are not exact: without slack a 60 Hz screen would skip to every third tick (20 fps).
const FRAME_SLACK_MS = 4;

/** True when enough time has passed since the last painted frame. */
export function isFrameDue(now: number, lastPaint: number): boolean {
  return now - lastPaint >= FRAME_MS - FRAME_SLACK_MS;
}
